module.exports = __webpack_public_path__ + "img/icon_check.5ba1305b.svg";